// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__82nCz","title":"ClientInsurance_title__1EvSN","itemText":"ClientInsurance_itemText__33kwR"};